import { render } from "./FromSubmission.vue?vue&type=template&id=8a4b325e&scoped=true"
import script from "./FromSubmission.vue?vue&type=script&lang=js"
export * from "./FromSubmission.vue?vue&type=script&lang=js"

import "./FromSubmission.vue?vue&type=style&index=0&id=8a4b325e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a4b325e"]])

export default __exports__